export const SOCKET_EVENTS = {
	ON: {
		MEETING_CREATED: 'MeetingCreatedEvent',
		USER_QUEUED: 'UserQueuedEvent',
		MATCH_APPROVED: 'MatchApprovedEvent',
		MATCH_PROPOSED: 'MatchProposedEvent',
		MEETING_ENDED: 'MeetingEndedEvent',
		MEETING_EXTENSION_COMPLETED: 'MeetingExtensionCompletedEvent',
		MEETING_EXTENSION_PROPOSED: 'MeetingExtensionProposedEvent',
		BUSINESS_ERROR: 'BusinessErrorEvent',
		PARTICIPANT_STATUS_RETRIEVED_EVENT: 'ParticipantStatusRetrievedEvent',
		MEETING_INFORMATION_RETRIEVED: 'MeetingInformationRetrievedEvent',
		SERVER_TIME: 'serverTime',
		MEETING_STARTED: 'MeetingStartedEvent',
		STUDENT_JOINED: 'StudentJoinedEvent',
		NOTIFICATION_CREATED: 'NotificationCreatedEvent',
		MEETING_ISSUE_OPTION_RETRIEVED: 'MeetingIssueOptionRetrievedEvent',
		MEETING_ISSUE_CREATED: 'MeetingIssueCreatedEvent',
		APPOINTMENT_CREATED: 'AppointmentCreatedEvent',
		APPOINTMENT_CANCELLED: 'AppointmentCancelledEvent',
		APPOINTMENT_COMPLETED: 'AppointmentCompletedEvent',
		VIDEO_CALL_MESSAGE: 'VideoCallMessage'
	},
	EMIT: {
		MEETING_INFORMATION_REQUESTED: 'MeetingInformationRequestedEvent',
		SEARCH_STARTED: 'SearchStartedEvent',
		MATCH_CONFIRMED: 'MatchConfirmedEvent',
		USER_CONNECTED: 'UserConnectedEvent',
		MEETING_TERMINATION_REQUESTED: 'MeetingTerminationRequestedEvent',
		SEARCH_ABORTED: 'SearchAbortedEvent',
		MEETING_EXTENSION_SUBMITTED: 'MeetingExtensionSubmittedEvent',
		COUNTERPART_PARTICIPANT_STATUS_REQUESTED: 'CounterpartParticipantStatusRequested',
		MEETING_ISSUE_OPTION_REQUESTED: 'MeetingIssueOptionRequestedEvent',
		MEETING_ISSUE_REPORTED: 'MeetingIssueReportedEvent',
		GENERIC_EVENT: 'GenericEvent',
		WHITE_BOARD: 'whiteboard',
		VIDEO_CALL_MESSAGE: 'VideoCallMessage'
	},
	PARAMS: {
		CONFIRMATION_TYPE: 'confirmationType'
	}
} as const;

export const CONFIRMATION_TYPES = {
	NO_RESPONSE: 'NO_RESPONSE',
	ACCEPTED: 'ACCEPTED'
};

export const MEETING_REASON_TYPES = {
	ENDED_BY_EXPERT: 'ENDED_BY_EXPERT',
	ENDED_BY_SYSTEM: 'ENDED_BY_SYSTEM',
	EXPIRED: 'EXPIRED'
};

export const MEETING_TYPE = {
	INSTANT: 'INSTANT',
	APPOINTMENT: 'APPOINTMENT'
};

export const CALL_SERVICE_TYPES = {
	COACHING: 'COACHING',
	GOT_IT: 'GOT_IT'
};

export const CALL_STATE_TYPES = {
	DEFAULT: 'DEFAULT',
	SEARCHING: 'SEARCHING',
	FOUND: 'FOUND',
	CONNECT: 'CONNECT'
} as const;

export const CONNECTION_STATUS = {
	NOT_CONNECTED: 'NOT_CONNECTED',
	CONNECTED: 'CONNECTED',
	NOT_JOINED: 'NOT_JOINED'
};

export const VIDEO_CALL_PROVIDER_NAMES = {
	GOOGLE_MEET: 'GOOGLE_MEET',
	JANUS: 'JANUS',
	ANTMEDIA: 'ANTMEDIA',
	IVS: 'IVS'
};
